import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import {
    FormBuilder,
    FormControl,
    FormGroup,
    ValidationErrors,
    Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { LocalStorageService, SessionStorageService } from "ngx-webstorage";
import { MessageService } from "primeng/api";
import { environment } from "src/environments/environment";
import { ConfirmedValidator, PatternValidator } from "../confirmed.validator";
import { MyserviceService } from "../myservice.service";

@Component({
    selector: "app-profile",
    templateUrl: "./profile.component.html",
    styleUrls: ["./profile.component.css"],
    providers: [MessageService],
})
export class ProfileComponent implements OnInit {
    public showloader: boolean = false;
    timeZones: any = [];
    profileUpdateForm: FormGroup;
    constructor(
        private myservice: MyserviceService,
        public session: SessionStorageService,
        public localstorage: LocalStorageService,
        private http: HttpClient,
        private messageService: MessageService,
        private fb: FormBuilder,
        private router: Router
    ) { }

    user: any = {};
    userDetails: any = {};
    loggedInUserDetails: any;
    responseData: any = {};
    response: any = {};
    resultMsg = "";
    resultMsg1 = "";
    Message = "";
    newPassword = "";
    confirmPassword = "";
    public edited: boolean = false;
    public pwdResultMessage: boolean = false;
    public newPwd: boolean = false;
    public confirmPwd: boolean = false;
    errors: ValidationErrors | null;
    profileForm: FormGroup;
    oldPasswordTextType: boolean;
    newPasswordTextType: boolean;
    confirmPasswordTextType: boolean;

    ngOnInit() {
        this.getTimeZones();
        this.initForms();
        this.loggedInUserDetails = this.session.retrieve("UserDetails");
    }
    //TO get current logged in user data
    profileData(){
        let headers = new HttpHeaders();
        headers = headers.append("authorization",this.localstorage.retrieve("token"));
        this.http.get(environment.apiUrl +"/user/getProfile/" +this.loggedInUserDetails.userId,
                { headers: headers })
            .subscribe((response: any) => {
                    this.profileUpdateForm.patchValue({
                        userName :response.userName,
                        designation : response.designation,
                        organization : response.organization,
                        email : response.email,
                        location : response.location,
                        officePhone : response.officePhone,
                        userId : this.loggedInUserDetails.userId,
                        timeZone : this.timeZones.filter((res) => res.id == response.timeZone)[0]
                    })
                    this.user.loginId = this.loggedInUserDetails.loginId;
                },
                (error) => {
                    //console.log("Error occured" + error);
                }
            );
    }
    initForms(){
        //For change password
        this.profileForm = this.fb.group(
            {
                oldPassword: new FormControl("", Validators.required),
                newPassword: new FormControl(
                    "",
                    Validators.compose([
                        Validators.required,
                        // 2. check whether the entered password has a number
                        PatternValidator(/\d/, { hasNumber: true }),
                        // 3. check whether the entered password has upper case letter
                        PatternValidator(/[A-Z]/, { hasCapitalCase: true }),
                        // 4. check whether the entered password has a lower-case letter
                        PatternValidator(/[a-z]/, { hasSmallCase: true }),
                        // 5. check whether the entered password has a special character
                        PatternValidator(
                            /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/,
                            { hasSpecialCharacters: true }
                        ),
                        // 6. min length 8 chars
                        Validators.minLength(8),
                    ])
                ),
                confirmPassword: new FormControl(
                    "",
                    Validators.compose([
                        Validators.required,
                    ])
                ),
            },

            {
                validator: ConfirmedValidator("newPassword", "confirmPassword"),
            }
        );
        //for profile update
        this.profileUpdateForm = this.fb.group(
            {
                userName: new FormControl("", Validators.required),
                designation: new FormControl(""),
                organization: new FormControl("", Validators.required),
                email: new FormControl("",Validators.required),
                location: new FormControl("", Validators.required),
                officePhone: new FormControl("",[Validators.pattern("[0-9 ]{10}")]),
                userId: new FormControl(""),
                loginId: new FormControl(""),
                timeZone: new FormControl("", Validators.required),
            }
        );
    }
    //To get list of timezones and patch est as default value
    getTimeZones() {
        this.myservice.getTimeZones(this.localstorage.retrieve("token")).subscribe((res) => {
            this.timeZones = res;
            this.profileData();
        })
    }
    get f() {
        return this.profileForm.controls;
    }

    update(userDetails) {
        this.userDetails = userDetails;
        let headers = new HttpHeaders();
        headers = headers.append(
            "authorization",
            this.localstorage.retrieve("token")
        );
        this.http
            .post(environment.apiUrl + "/user/updateProfile", { ...userDetails, timeZone: userDetails.timeZone.id }, {
                headers: headers,
                responseType: "text",
            })
            .subscribe(
                (data: any) => {
                    this.responseData = data;
                    this.resultMsg = this.responseData;
                    if (this.resultMsg == "") {
                        this.messageService.add({
                            severity: "error",
                            summary: "Error",
                            detail: "Something went wrong please try again",
                        });
                    }
                    else {
                        this.messageService.add({
                            severity: "success",
                            summary: "Success",
                            detail: this.resultMsg + ', Please login again.',
                        });
                        setTimeout(() => {
                            this.logout()
                        }, 5000)
                    }
                },
                (error) => {
                    //console.log("Error occured");
                }
            );
    }

    touched() {
        this.profileForm.reset();
    }

    changePassword(profileForm) {
        if (profileForm.newPassword == "") {
            alert("please enter New password and  Confirm password ");
            return false;
        }
        if (profileForm.confirmPassword == "") {
            alert("please enter New password and  Confirm password");
            return false;
        }
        if (profileForm.newPassword == profileForm.confirmPassword) {
            let headers = new HttpHeaders();
            headers = headers.append(
                "authorization",
                this.localstorage.retrieve("token")
            );
            profileForm.loginId = this.user.loginId;
            this.http
                .post(environment.apiUrl + "/user/resetPassword", profileForm, {
                    headers: headers,
                    responseType: "text",
                })
                .subscribe((data) => {
                    this.response = data;
                    this.resultMsg1 = this.response;
                    if (
                        (this.resultMsg1 ==
                            "Something went wrong! Please try again.") || (this.resultMsg1 ==
                                "Please enter valid old password!")
                    ) {
                        this.messageService.add({
                            severity: "error",
                            summary: "Error",
                            detail: this.resultMsg1,
                        });
                    } else {
                        this.messageService.add({
                            severity: "success",
                            summary: "Success",
                            detail: this.resultMsg1,
                        });
                        setTimeout(() => {
                            this.logout()
                        }, 5000)
                    }
                });
        } else {
            alert("New password and  Confirm password should be equal");
            this.edited = true;
            setTimeout(
                function () {
                    this.edited = false;
                }.bind(this),
                2000
            );
        }
    }
    logout() {
        this.localstorage.store("token", "")
        sessionStorage.clear();
        this.session.clear();
        this.router.navigateByUrl("login");
    }

    oldPasswordToggle() {
        this.oldPasswordTextType = !this.oldPasswordTextType;
    }

    newPasswordToggle() {
        this.newPasswordTextType = !this.newPasswordTextType;
    }

    confirmPasswordToggle() {
        this.confirmPasswordTextType = !this.confirmPasswordTextType;
    }
}
